import React, { ComponentProps } from "react";

function GiftSolidIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={19}
      height={18}
      viewBox="0 0 19 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="gift 1" clipPath="url(#clip0_68_81344)">
        <path
          id="Vector"
          d="M8.33191 10.1056V17.9507H2.72827C2.10879 17.9507 1.60754 17.45 1.60754 16.83V10.1056H8.33191ZM8.33191 8.98486V5.62268H5.78572C4.79024 5.62268 3.88759 5.20041 3.32919 4.50195H1.60754C0.988552 4.50195 0.486816 5.00376 0.486816 5.62268V7.86414C0.486816 8.48061 0.991144 8.98486 1.60754 8.98486H8.33191ZM10.5734 17.9507H16.177C16.7964 17.9507 17.2977 17.45 17.2977 16.83V10.1056H10.5734V17.9507ZM17.2977 4.50195H15.5761C15.0177 5.20041 14.115 5.62268 13.1196 5.62268H10.5734V8.98486H17.2977C17.9141 8.98486 18.4185 8.48061 18.4185 7.86414V5.62268C18.4185 5.00376 17.9167 4.50195 17.2977 4.50195Z"
        />
        <path
          id="Vector_2"
          opacity="0.4"
          d="M8.33148 17.9512H10.5729V10.1061H8.33148V17.9512ZM13.1304 0.0195312C11.3504 0.0195312 10.1064 1.53777 9.45221 2.59412C8.79798 1.53777 7.55401 0.0195312 5.77409 0.0195312C3.79548 0.0195312 2.72784 1.46916 2.72784 2.83305C2.72784 3.40238 2.90748 3.95003 3.24737 4.41688C3.79719 5.17211 4.74596 5.62317 5.78529 5.62317H8.33148V8.98535H10.5729V5.62317H13.1191C14.1585 5.62317 15.1072 5.17211 15.657 4.41688C15.9969 3.95003 16.1766 3.40238 16.1766 2.83305C16.1766 1.46916 15.1089 0.0195312 13.1304 0.0195312ZM5.78529 3.94208C4.83415 3.94208 4.40894 3.34144 4.40894 2.83305C4.40894 2.37775 4.7697 1.70062 5.77409 1.70062C6.82796 1.70062 7.78986 2.97895 8.29208 3.94208H5.78529ZM13.1191 3.94208H10.6123C11.1146 2.97895 12.0765 1.70062 13.1303 1.70062C14.1347 1.70062 14.4955 2.37775 14.4955 2.83305C14.4955 3.34144 14.0703 3.94208 13.1191 3.94208Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_68_81344">
          <rect
            width="17.9316"
            height="17.9316"
            fill="white"
            transform="translate(0.486816 0.0195312)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GiftSolidIcon;
